import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import { MmuLogger } from '../../logging';


/**
 * Organization association route guard factory for Miele MOVE. Check if the user is assigned to an organization yet.
 *
 * @returns {CanActivateFn | CanActivateChildFn}
 *
 * @example ```typescript
 * {
 *   path: 'protected',
 *   component: ProtectedComponent,
 *   canActivate: [hasOrganization()]
 * }
 * ```
 */
export function hasOrganization(): CanActivateFn | CanActivateChildFn {
  return (_, state): true | UrlTree => {
    const userService = inject(MmuUserService);
    const oid = userService.user.oid;
    const allowNavigation = oid !== undefined && oid !== null;

    if (allowNavigation) {
      return true;
    }

    const router = inject(Router);
    const logger = inject(MmuLogger);
    logger.warn(`Tried to access a protected page at "${state.url}", but user is not assigned to an organization yet.`, 'oid:', oid);
    return router.createUrlTree(['/user/organization/association'], {
      queryParams: {
        redirect: state.url
      }
    });
  };
}
